var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef } from "react";
var CardTitle = forwardRef(function (_a, ref) {
    var children = _a.children, _b = _a.as, Tag = _b === void 0 ? "h3" : _b, className = _a.className, style = _a.style, otherProps = __rest(_a, ["children", "as", "className", "style"]);
    var combinedClassName = ["fr-card__title"];
    if (className) {
        combinedClassName.push(className);
    }
    return (React.createElement(Tag, __assign({}, otherProps, { className: combinedClassName.join(" "), style: style, ref: ref }), children));
});
export default CardTitle;
